export default __webpack_public_path__ + "static/media/NicolaSalimova.aa78809f.jpg";